import React, { useRef } from "react";

import { faCircleInfo, faTimes } from "@fortawesome/pro-regular-svg-icons";
import { useOnClickOutside } from "usehooks-ts";

import { Icon } from "src/base-components/Icon";
import { CustomPopover } from "src/base-components/Popover";
import { JsonSchema } from "src/jsonSchema/types";
import { JSONSchemaRenderer } from "src/jsonSchema/viewer";
import { createTitleOnlyHeaderRenderer } from "src/jsonSchema/viewer/JSONSchemaRenderer";

type Props = {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  name: string;
  schema: JsonSchema;
};
export const ComplexSchemaObjectPopover: React.FC<Props> = ({
  isOpen,
  onOpen,
  onClose,
  name,
  schema,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  useOnClickOutside(ref, onClose, "mousedown", {
    capture: true,
    passive: true,
  });

  return (
    <CustomPopover
      button={
        <Icon
          color="text-gray-500"
          icon={faCircleInfo}
          size="xs"
          onClick={onOpen}
        />
      }
      className="h-[375px] w-[480px]"
      dataLoc="schema-field-info"
      isOpen={isOpen}
      placement="bottom-end"
    >
      <div ref={ref} className="flex h-full flex-col">
        <div className="flex items-center justify-between border-gray-100 border-b bg-white px-4 pt-1 pb-3">
          <div>
            <h3 className="font-inter-semibold-13px text-gray-800 capitalize">
              {name ?? "Schema"}
            </h3>
          </div>
          <Icon
            color="text-gray-500"
            icon={faTimes}
            size="2xs"
            onClick={onClose}
          />
        </div>
        <div className="decideScrollbar flex-1">
          <div className="m-4 rounded-md border border-gray-200 p-4">
            <JSONSchemaRenderer
              displayOptions={{
                showRequired: true,
                showTypeLabels: false,
                showDataPaths: false,
                showPrimitiveTypeLabels: false,
                showPrimitiveDataPath: false,
                customLabelAndTypeRenderer: createTitleOnlyHeaderRenderer(),
              }}
              schema={schema}
            />
          </div>
        </div>
      </div>
    </CustomPopover>
  );
};
